var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M7.9 17.3c.2-5.3 3.5-10.2 8.7-12.1 6.9-2.6 14.6 1 17.2 7.9.5 1.4.8 2.8.8 4.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M12.4 18.4v5.7c0 .9.2 1.8.5 2.7 1.6 4.4 6.6 6.7 11 5 3.4-1.2 5.5-4.4 5.6-7.7v-7.8s-1.9 2.4-6.5 4c-3.8 1.3-5.3.8-5.3.8l1.6-4.7-6.9 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M34.6 25.1c-.2 5.3-3.5 10.1-8.7 12.1-.3.1-.7.2-1 .3M7.9 24.4h-.4c-1.4 0-2.4-1.1-2.4-2.4v-2.2c0-1.4 1.1-2.4 2.4-2.4h.4M34.7 17.3h.4c1.4 0 2.4 1.1 2.4 2.4v2.2c0 1.4-1.1 2.4-2.4 2.4h-.4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 20.1,
    cy: 38,
    r: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.d2dbdbc8545f6e372e78761afc8c8af6.svg";
export { ForwardRef as ReactComponent };